<template>
  <div>
    This event will be started.
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String
    }
  };
</script>
